var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowItWorks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C14.6948 2 18.5 5.80616 18.5 10.5C18.5 15.1938 14.6948 19 10 19C5.30616 19 1.5 15.1938 1.5 10.5C1.5 5.80616 5.30616 2 10 2Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2924 5.408C8.74038 5.408 7.33238 6.416 6.96438 7.744C6.88438 8 6.91638 8.224 7.20438 8.32L7.50838 8.416C7.81238 8.512 7.97238 8.368 8.10038 8.08C8.40438 7.232 9.33238 6.56 10.2604 6.56C11.6204 6.56 12.5164 7.296 12.5164 8.384C12.5164 9.552 11.5724 10.192 10.9164 10.768C10.1644 11.424 9.82838 12.048 9.82838 12.944V13.136C9.82838 13.424 9.97238 13.568 10.2604 13.568H10.6124C10.9004 13.568 11.0444 13.424 11.0444 13.136V12.912C11.0444 12.368 11.2044 12.016 11.8444 11.456C12.6604 10.752 13.8444 9.824 13.8444 8.336C13.8444 6.576 12.4204 5.408 10.2924 5.408ZM10.4364 14.24C9.89238 14.24 9.46038 14.688 9.46038 15.216C9.46038 15.76 9.89238 16.192 10.4364 16.192C10.9644 16.192 11.4124 15.76 11.4124 15.216C11.4124 14.688 10.9644 14.24 10.4364 14.24Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorks);
export default __webpack_public_path__ + "static/media/how-it-works.454e3ca4.svg";
export { ForwardRef as ReactComponent };